<template>
  <button
    v-bind="$attrs"
    class="eds-button"
    :class="[
      inverse ? `button-${motif}-inverse` : `button-${motif}`,
      {
        'button-compact': compact,
        'flex-row-reverse': iconPlacement === 'left',
      },
      className,
    ]"
    :style="{
      cursor: 'pointer',
      ...style,
    }"
    :disabled="disabled"
  >
    <slot name="icon" />
    <span
      v-if="$slots.default || label"
      class="button-label"
      :class="[{ 'ev-pl-4': $slots.icon }, labelClass]"
      :style="labelStyle"
    >
      <slot />
      <div v-if="!($slots.default || $slots.icon)">
        {{ label }}
      </div>
    </span>
  </button>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Button',
    props: {
      motif: {
        type: String,
        required: false,
        default: 'primary',
        validator(value: string) {
          return ['primary', 'basic', 'tertiary', 'danger'].includes(value);
        },
      },
      label: {
        type: String,
        required: false,
      },
      inverse: {
        type: Boolean,
        required: false,
        default: false,
      },
      compact: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
      },
      iconPlacement: {
        type: String,
        required: false,
        default: 'right',
        validator: (value: string) => ['right', 'left'].includes(value),
      },
      style: {
        type: Object,
        required: false,
      },
      className: {
        type: String,
        required: false,
        default: '',
      },
      labelClass: {
        type: String,
        required: false,
        default: '',
      },
      labelStyle: {
        type: Object,
        required: false,
      },
    },
  });
</script>

<style></style>
